import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonimageComponent } from '../../components/person/personimage/personimage.component';

@Component({
  selector: 'app-alertbox',
  standalone: true,
  imports: [CommonModule, PersonimageComponent],
  templateUrl: './alertbox.component.html',
  styleUrl: './alertbox.component.css'
})
export class AlertboxComponent {
  @Input() alerttext: string;
  @Input() alerticon: string;
  @Input() alerttype: string;
  @Input() alertdisplay: string;
  @Input() confirmmessage: string; // Additional message for confirm dialogs
  @Input() confirmButtonText: string = 'Confirm';
  @Input() cancelButtonText: string = 'Cancel';
  
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onConfirm(): void {
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
